export default "__VITE_ASSET__BNOL2IG6__"